(()=>{
  let patched=false;
  function component(long_name,types){return {long_name,short_name:long_name,types};}
  function patch(){
    if(patched||!window.google?.maps?.Geocoder)return false;
    const proto=google.maps.Geocoder.prototype;
    if(proto.__caraviumFallback)return true;
    const original=proto.geocode;
    proto.geocode=function(request,callback){
      if(!request?.address)return original.call(this,request,callback);
      const q=String(request.address||'').trim();
      return original.call(this,request,async(results,status)=>{
        if(status==='OK'&&results?.length){callback(results,status);return;}
        try{
          const url='https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&countrycodes=es&limit=5&q='+encodeURIComponent(q);
          const r=await fetch(url,{headers:{'Accept':'application/json','Accept-Language':'es'}});
          if(!r.ok)throw new Error('search');
          const rows=await r.json();
          if(!rows?.length){callback([], 'ZERO_RESULTS');return;}
          const x=rows[0],a=x.address||{},lat=Number(x.lat),lng=Number(x.lon),parts=[];
          const town=a.city||a.town||a.village||a.municipality||a.hamlet||'';
          const province=a.province||a.state_district||a.county||'';
          if(town)parts.push(component(town,['locality']));
          if(province)parts.push(component(province,['administrative_area_level_2']));
          if(a.state)parts.push(component(a.state,['administrative_area_level_1']));
          if(a.postcode)parts.push(component(a.postcode,['postal_code']));
          if(a.country)parts.push(component(a.country,['country']));
          callback([{formatted_address:x.display_name||q,address_components:parts,geometry:{location:{lat:()=>lat,lng:()=>lng}}}], 'OK');
        }catch(err){callback([],status||'ZERO_RESULTS');}
      });
    };
    proto.__caraviumFallback=true;patched=true;return true;
  }
  if(!patch()){
    const timer=setInterval(()=>{if(patch())clearInterval(timer);},150);
    setTimeout(()=>clearInterval(timer),20000);
  }
})();